import { theme } from '@provi/provi-components'
import styled, { keyframes } from 'styled-components'

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const Spinner = styled.span`
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: ${theme.colors.white100};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  flex-shrink: 0;
`

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`

export const ModalContent = styled.div`
  background: ${theme.colors.white100};
  border-radius: 8px;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

  @media (max-width: 800px) {
    padding: 20px;
    width: 95%;
  }
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
`

export const ModalTitle = styled.h3`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 22px;
  color: ${theme.colors.black100};
  margin: 0;

  @media (max-width: 800px) {
    font-size: 18px;
  }
`

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  color: ${theme.colors.black100};
  cursor: pointer;
  opacity: 0.5;
  padding: 5px;

  :hover {
    opacity: 1;
  }
`

export const YearSelect = styled.select`
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 30px;
  border: 2px solid #cfcfcf;
  border-radius: 4px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 16px;
  color: ${theme.colors.black100};
  background: ${theme.colors.white100};
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23333' d='M6 8L0 0h12z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 16px center;

  :focus {
    outline: none;
    border-color: ${theme.colors.bluePrimary};
  }
`

export const DownloadButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 15px 20px;
  border: none;
  border-radius: 4px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  font-size: 16px;

  /* Handle Disabled State */
  background: ${({ disabled }) => (disabled ? '#cfcfcf' : theme.colors.bluePrimary)};
  color: ${theme.colors.white100};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  :hover {
    background: ${({ disabled }) => !disabled && theme.colors.blueSecundaryDark};
  }

  :active {
    background: ${({ disabled }) => !disabled && theme.colors.bluePrimaryDark};
  }
`
